module.exports = __webpack_public_path__ + "static/sui-button-group-vertical-d71223e3fc3f4d7f03ba07c3e008cedc.png";